import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './MfpartyAPI';
import {getColumns} from './MfpartyStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getMfpartyView} from './MfpartyView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteMfpartyObj  ,setSelectedMfpartyId,setMfpartyManagePartyModal,setMfpartySelectPartyModal,setSelectedActionId , setShowEditForMfparty} from 'store/slice/ManufSlice';

import MfpartyListTable from './components/MfpartyListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import MfpartyFilterCriteria from './MfpartyFilterCriteria';


import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import HowToRegIcon from '@mui/icons-material/HowToReg';

import ManagePartyActionModal from './action/ManageParty/ManagePartyActionModal';
import SelectPartyActionModal from './action/SelectParty/SelectPartyActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function MfpartyListImpl( {tableList, cardList, setShowEdit, setMfpartyId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, mfpartyObj} = useSelector((state)=>state.manufslice.mfpartyDashboard);
  const { mfpartyList } = useSelector((state) => state.manufslice.mfpartyDashboard);

  useEffect(() => {
  }, [mfpartyList, mfpartyObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedMfpartyId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteMfpartyObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedMfpartyId(id));
    dispatch(setShowEditForMfparty(true));
  }
  
  const createMfparty=()=>{
    dispatch(setSelectedMfpartyId(-1));
    dispatch(setShowEditForMfparty(true));
  }


  const ManagePartyCallBack = (id) =>{
    dispatch(setSelectedMfpartyId(id));
    dispatch(setMfpartyManagePartyModal(true));
  }
  const SelectPartyCallBack = (id) =>{
    dispatch(setSelectedMfpartyId(id));
    dispatch(setMfpartySelectPartyModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const mfpartyTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    mfpartyList:mfpartyList,
    cardList:getMfpartyView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:61, title:'Manage Party', callBackMethod:ManagePartyCallBack, icon:<ManageAccountsIcon/>, status:'Draft', role:''},
        {id:62, title:'Select Party', callBackMethod:SelectPartyCallBack, icon:<HowToRegIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:mfpartyTransformation(tableList),
      mfpartyList:mfpartyList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        // {id:61, title:'Manage Party', callBackMethod:ManagePartyCallBack, icon:<ManageAccountsIcon/>, status:'Draft', role:''},
        // {id:62, title:'Select Party', callBackMethod:SelectPartyCallBack, icon:<HowToRegIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">Party List</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < MfpartyFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Mfparty" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createMfparty()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                  
                  < MfpartyListTable 
                    payload={getPayload().tableView}
                    />
                
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<ManagePartyActionModal/>
<SelectPartyActionModal/>
    </>
);


}